// extracted by mini-css-extract-plugin
export default {"icon":"MetricRegressionFlag__icon__pNK22"};